import React from 'react';
import PropTypes from 'prop-types';
import { FeatureFlag } from 'site-modules/shared/components/feature-flag/feature-flag';
import { GlobalNavigationSearch } from 'site-modules/shared/components/inventory/global-search/global-navigation-search/global-navigation-search';

import './search-box.scss';

export function SearchBox({
  searchBarComponent: SearchBarComponent = GlobalNavigationSearch,
  isMobile = false,
  isOpenMenu = false,
  withAiLink = true,
  use2027Theme = false,
}) {
  return (
    <FeatureFlag name="disable-global-nav-llm">
      {disableLlm => (
        <SearchBarComponent
          isMobile={isMobile}
          withLlmSearchDisabled={disableLlm}
          isOpenMenu={isOpenMenu}
          withAiLink={withAiLink}
          use2027Theme={use2027Theme}
        />
      )}
    </FeatureFlag>
  );
}

SearchBox.propTypes = {
  searchBarComponent: PropTypes.elementType,
  isMobile: PropTypes.bool,
  isOpenMenu: PropTypes.bool,
  withAiLink: PropTypes.bool,
  use2027Theme: PropTypes.bool,
};
